import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MAP_DEFAULT_TIME_RANGE } from '@/console/features/map/map.constants';
import { TMapTimeRange } from '@/console/features/map/map.types';
import {
  normalizeMapTimeRange,
  normalizeRefreshInterval,
  parseRefreshInterval,
} from '@/console/features/map/map.utils';

type TMapState = {
  refreshInterval: number;
  timeRange: TMapTimeRange;
  selectedGatewayId: string | null;
};

const initialState: TMapState = {
  refreshInterval: normalizeRefreshInterval(parseRefreshInterval()),
  timeRange: MAP_DEFAULT_TIME_RANGE,
  selectedGatewayId: null,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setRefreshInterval: (state, action: PayloadAction<number>) => {
      const nextInterval = normalizeRefreshInterval(action.payload);
      if (state.refreshInterval === nextInterval) {
        return;
      }
      state.refreshInterval = nextInterval;
    },
    setTimeRange: (state, action: PayloadAction<TMapTimeRange>) => {
      const nextTimeRange = normalizeMapTimeRange(action.payload);
      if (state.timeRange === nextTimeRange) {
        return;
      }
      state.timeRange = nextTimeRange;
    },
    setSelectedGatewayId: (state, action: PayloadAction<string | null>) => {
      if (state.selectedGatewayId === action.payload) {
        return;
      }
      state.selectedGatewayId = action.payload;
    },
  },
});

export const { setRefreshInterval, setTimeRange, setSelectedGatewayId } =
  mapSlice.actions;

export const mapReducer = mapSlice.reducer;
